import T from 'prop-types'
import React from 'react'
import Container from 'components/Container'
import Button from 'components/Button'
import useSession from 'hooks/useSession'
import { removeItem } from 'lib/storage'
import Header from 'apps/booking/components/Header'

export default function BookingUnavailablePage({
  match: {
    params: { orgUnit },
  },
}) {
  const { clearSession } = useSession()

  // Flush the session storage to prevent user from going back and trying again
  removeItem('bookingState')

  return (
    <>
      <Header />

      <Container size="tight">
        <h1>Du kan ikke bestille time enda</h1>
        <p>Din kommune har ikke gitt deg adgang til å bestille time til vaksinasjon enda.</p>
        <p>
          Kommunene gir tilgang ut fra en prioriteringsliste som helsemyndighetene har laget. Denne
          listen tar høyde for både alder og for ulike sykdommer, og sier hvilken rekkefølge folk
          skal prioriteres i.
        </p>
        <p>
          Dersom du mener at din alder og/eller sykehistorie gjør du burde ha tilgang til å bestille
          vaksinetime, bør du ta kontakt med vaksinasjonskontoret i din kommune.
        </p>
        <Button onClick={() => clearSession(`/${orgUnit}`)} primary>
          Avslutt og logg ut
        </Button>
      </Container>
    </>
  )
}

BookingUnavailablePage.propTypes = {
  match: T.shape({
    params: T.shape({
      orgUnit: T.string.isRequired,
    }).isRequired,
  }).isRequired,
}
